import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { ArrowLeft, CheckCircle2, Clock, XCircle } from "lucide-react";
import Logo from "../components/Logo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentResult({ kind }) {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");
  const [paymentStatus, setPaymentStatus] = useState(kind === "success" ? "pending" : "none");

  useEffect(() => {
    if (kind !== "success" || !sessionId) return;
    let stop = false;
    const check = async () => {
      try {
        const { data } = await fetch(`${API}/payments/status/${sessionId}`).then((r) => {
          if (!r.ok) throw new Error("status");
          return r.json();
        });
        if (!stop && data.payment_status === "paid") setPaymentStatus("paid");
      } catch (e) {
        /* réessaye au prochain tick */
      }
    };
    check();
    const interval = setInterval(() => {
      if (!stop && paymentStatus !== "paid") check();
      else clearInterval(interval);
    }, 3000);
    return () => {
      stop = true;
      clearInterval(interval);
    };
  }, [kind, sessionId]);

  const success = kind === "success";
  const paid = paymentStatus === "paid";

  return (
    <div className="min-h-screen flex items-center justify-center px-5">
      <div className="w-full max-w-md text-center glass rounded-3xl p-10" data-testid="payment-result">
        <div className="flex justify-center">
          <Logo />
        </div>
        {success ? (
          paid ? (
            <CheckCircle2 size={56} className="mx-auto mt-8 text-emerald-400" data-testid="payment-success-icon" />
          ) : (
            <Clock size={56} className="mx-auto mt-8 text-amber-300 animate-pulse" data-testid="payment-pending-icon" />
          )
        ) : (
          <XCircle size={56} className="mx-auto mt-8 text-mist" data-testid="payment-cancel-icon" />
        )}
        <h1 className="mt-6 font-display font-bold text-2xl text-white">
          {success ? (paid ? "Paiement confirmé" : "Paiement reçu — confirmation en cours") : "Paiement annulé"}
        </h1>
        <p className="mt-4 text-sm text-mist leading-relaxed">
          {success
            ? paid
              ? "Merci ! Votre acompte est bien arrivé. L'équipe GiulIATeck revient vers vous pour lancer l'installation."
              : "Votre paiement est en cours de vérification. Cette page se met à jour automatiquement."
            : "Aucun montant n'a été débité. Si vous changez d'avis, recontactez-nous et nous vous renverrons le lien."}
        </p>
        <a
          href="/"
          data-testid="payment-back-home"
          className="mt-8 inline-flex items-center gap-2 text-sm text-viol-pale hover:text-white transition-colors"
        >
          <ArrowLeft size={15} />
          Retour au site
        </a>
      </div>
    </div>
  );
}
